import React from 'react';
import './styles.css';
import Section from '../../../../GbsUI/UI/Section';

const SignupLayout = ({title, description, footer, contentBefore, children, stickyFooter}) => {
  return (
    <div className={'signup'}>
      {!!contentBefore && <p className={'signup__content-before'}>{contentBefore}</p>}
      <Section
        title={title}
        description={description}
        footer={footer}
        stickyFooter={stickyFooter}
      >
        <div className={'signup__content-wrap'}>
          {children}
        </div>
      </Section>
    </div>
  )
}

export default SignupLayout;
